
export class Content {
    repository?: string = "insights";
    query?: string = "";
    tags?: boolean = false;
    ancestors?: string[] = [];
}
